import React, { useState } from 'react'
import { ChromePicker } from 'react-color'

export default function Input({ color, setColor }) {
	const [showPicker, setShowPicker] = useState(false)

	return (
		<div>
			<input
				onClick={() => {
					setShowPicker(s => !s)
				}}
				value={color}
				onChange={(e) => setColor(e.target.value)}
				type="text"
				name="color"
				id="colorValue"
				className="block w-full appearance-none bg-white border border-gray-200 hover:border-gray-500 px-4 py-2 pr-8 rounded leading-tight focus:outline-none focus:shadow-outline"
			/>
			{showPicker ? (
				<>
					<div
						className="fixed z-10 top-0 bottom-0 left-0 right-0"
					></div>
					<ChromePicker
						className="absolute z-20 mt-4"
						color={color}
						onChange={(color) => setColor(color.hex)}
					/>
				</>
			) : null}
		</div>
	)
}
